import React from 'react';
import { 
  Palette, 
  Users, 
  Globe, 
  Clock, 
  Shirt,
  Sparkles,
  Target,
  TrendingUp,
  Camera,
  Scissors,
  ShoppingBag,
  BarChart3,
  Calendar,
  MapPin,
  CheckCircle,
  Zap,
  Eye,
  Award,
  Settings
} from 'lucide-react';
import { Link } from 'react-router-dom';
const InforPLMFashion = () => {
  return (
    <div className="min-h-screen w-full overflow-x-hidden" style={{ backgroundColor: '#f8fafc' }}>
      {/* Hero Section */}
      <section 
        className="relative overflow-hidden py-20 px-4 sm:px-6 lg:px-8"
        style={{ 
          background: 'linear-gradient(to bottom right, #6366f1, #8b5cf6, #a855f7)', 
          color: '#ffffff'
        }}
      >
        <div className="absolute inset-0 opacity-20" style={{ backgroundColor: '#000000' }}></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="max-w-2xl">
              <div className="flex items-center mb-4">
                <Sparkles className="w-8 h-8 mr-2" style={{ color: '#f59e0b' }} />
                <span 
                  className="font-semibold uppercase tracking-wider text-sm"
                  style={{ color: '#f59e0b' }}
                >
                  Fashion Innovation
                </span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
                Transform Your Fashion Development Lifecycle
              </h2>
              <p className="text-xl mb-8 leading-relaxed" style={{ color: '#e0e7ff' }}>
                Cloud-based solution designed for the fast-paced fashion industry. 
                Manage collections, streamline workflows, and accelerate time-to-market.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">

                <Link to="/contact">
                 <button 
                  className="px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105"
                  style={{ backgroundColor: '#f59e0b', color: '#ffffff' }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#d97706';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#f59e0b';
                  }}
                >
                  Start Your Journey
                </button>
                
                </Link>

               
              </div>
            </div>
            <div className="relative max-w-lg mx-auto lg:max-w-none">
              <div 
                className="absolute -inset-4 rounded-xl opacity-20 transform rotate-3"
                style={{ background: 'linear-gradient(to bottom right, #f59e0b, #dc2626)' }}
              ></div>
              <img 
                src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop&crop=center" 
                alt="Fashion Design Studio" 
                className="relative rounded-xl shadow-2xl w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#ffffff' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: '#fef3c7' }}
              >
                <Clock className="w-8 h-8" style={{ color: '#d97706' }} />
              </div>
              <div className="text-3xl font-bold mb-2" style={{ color: '#111827' }}>60%</div>
              <div className="text-sm lg:text-base" style={{ color: '#6b7280' }}>Faster Time-to-Market</div>
            </div>
            <div className="text-center">
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: '#dbeafe' }}
              >
                <Users className="w-8 h-8" style={{ color: '#2563eb' }} />
              </div>
              <div className="text-3xl font-bold mb-2" style={{ color: '#111827' }}>95%</div>
              <div className="text-sm lg:text-base" style={{ color: '#6b7280' }}>Team Collaboration</div>
            </div>
            <div className="text-center">
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: '#dcfce7' }}
              >
                <Globe className="w-8 h-8" style={{ color: '#16a34a' }} />
              </div>
              <div className="text-3xl font-bold mb-2" style={{ color: '#111827' }}>40%</div>
              <div className="text-sm lg:text-base" style={{ color: '#6b7280' }}>Supply Chain Efficiency</div>
            </div>
            <div className="text-center">
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: '#fee2e2' }}
              >
                <TrendingUp className="w-8 h-8" style={{ color: '#dc2626' }} />
              </div>
              <div className="text-3xl font-bold mb-2" style={{ color: '#111827' }}>85%</div>
              <div className="text-sm lg:text-base" style={{ color: '#6b7280' }}>Decision Speed</div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Feature Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {/* Card 1 - Streamlined Product Lifecycle */}
          <div 
            className="rounded-xl shadow-lg p-8 border-l-4 transition-all duration-300 cursor-pointer hover:shadow-2xl hover:-translate-y-2"
            style={{ backgroundColor: '#ffffff', borderLeftColor: '#10b981' }}
          >
            <div className="flex items-center mb-6">
              <div 
                className="w-14 h-14 rounded-xl flex items-center justify-center shadow-lg"
                style={{ background: 'linear-gradient(to bottom right, #10b981, #059669)' }}
              >
                <Shirt className="w-7 h-7" style={{ color: '#ffffff' }} />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4" style={{ color: '#111827' }}>
              Streamlined Lifecycle
            </h3>
            <p className="mb-6 leading-relaxed" style={{ color: '#6b7280' }}>
              Centralized platform for concept to production with real-time collaboration across teams.
            </p>
            <div className="flex items-center font-semibold" style={{ color: '#10b981' }}>
              <Target className="w-4 h-4 mr-2" />
              <span>Reduce Time-to-Market</span>
            </div>
          </div>

          {/* Card 2 - Design Innovation */}
          <div 
            className="rounded-xl shadow-lg p-8 border-l-4 transition-all duration-300 cursor-pointer hover:shadow-2xl hover:-translate-y-2"
            style={{ backgroundColor: '#ffffff', borderLeftColor: '#3b82f6' }}
          >
            <div className="flex items-center mb-6">
              <div 
                className="w-14 h-14 rounded-xl flex items-center justify-center shadow-lg"
                style={{ background: 'linear-gradient(to bottom right, #3b82f6, #2563eb)' }}
              >
                <Palette className="w-7 h-7" style={{ color: '#ffffff' }} />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4" style={{ color: '#111827' }}>
              Design Innovation
            </h3>
            <p className="mb-6 leading-relaxed" style={{ color: '#6b7280' }}>
              Creative design processes with Adobe integration and seamless workflow management.
            </p>
            <div className="flex items-center font-semibold" style={{ color: '#3b82f6' }}>
              <Sparkles className="w-4 h-4 mr-2" />
              <span>Accelerate Innovation</span>
            </div>
          </div>

          {/* Card 3 - Global Sourcing */}
          <div 
            className="rounded-xl shadow-lg p-8 border-l-4 transition-all duration-300 cursor-pointer hover:shadow-2xl hover:-translate-y-2"
            style={{ backgroundColor: '#ffffff', borderLeftColor: '#f59e0b' }}
          >
            <div className="flex items-center mb-6">
              <div 
                className="w-14 h-14 rounded-xl flex items-center justify-center shadow-lg"
                style={{ background: 'linear-gradient(to bottom right, #f59e0b, #d97706)' }}
              >
                <Globe className="w-7 h-7" style={{ color: '#ffffff' }} />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4" style={{ color: '#111827' }}>
              Global Sourcing
            </h3>
            <p className="mb-6 leading-relaxed" style={{ color: '#6b7280' }}>
              Integrated supplier portals with real-time collaboration and performance tracking.
            </p>
            <div className="flex items-center font-semibold" style={{ color: '#f59e0b' }}>
              <Eye className="w-4 h-4 mr-2" />
              <span>Supply Chain Visibility</span>
            </div>
          </div>

          {/* Card 4 - Smart Decisions */}
          <div 
            className="rounded-xl shadow-lg p-8 border-l-4 transition-all duration-300 cursor-pointer hover:shadow-2xl hover:-translate-y-2"
            style={{ backgroundColor: '#ffffff', borderLeftColor: '#8b5cf6' }}
          >
            <div className="flex items-center mb-6">
              <div 
                className="w-14 h-14 rounded-xl flex items-center justify-center shadow-lg"
                style={{ background: 'linear-gradient(to bottom right, #8b5cf6, #7c3aed)' }}
              >
                <Zap className="w-7 h-7" style={{ color: '#ffffff' }} />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4" style={{ color: '#111827' }}>
              Smart Decisions
            </h3>
            <p className="mb-6 leading-relaxed" style={{ color: '#6b7280' }}>
              Real-time analytics and costing tools for strategic decision-making and forecasting.
            </p>
            <div className="flex items-center font-semibold" style={{ color: '#8b5cf6' }}>
              <BarChart3 className="w-4 h-4 mr-2" />
              <span>Data-Driven Insights</span>
            </div>
          </div>
        </div>

        {/* Detailed Sections */}
        <section className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="max-w-2xl">
            <div className="flex items-center mb-8">
              <div 
                className="w-20 h-20 rounded-xl flex items-center justify-center mr-6 shadow-xl"
                style={{ background: 'linear-gradient(to bottom right, #10b981, #059669)' }}
              >
                <Shirt className="w-10 h-10" style={{ color: '#ffffff' }} />
              </div>
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold mb-2" style={{ color: '#111827' }}>
                  Streamlined Product Lifecycle
                </h2>
                <p className="font-semibold" style={{ color: '#10b981' }}>For Fashion Teams</p>
              </div>
            </div>
            <p className="text-lg mb-8 leading-relaxed" style={{ color: '#6b7280' }}>
              Cloud-based solution specifically designed for the fast-paced fashion industry. 
              Organize your entire product development from concept to production.
            </p>
            <div className="space-y-6">
              <div 
                className="flex items-start gap-4 p-4 rounded-xl"
                style={{ backgroundColor: '#ecfdf5' }}
              >
                <CheckCircle className="w-6 h-6 mt-1 flex-shrink-0" style={{ color: '#10b981' }} />
                <div>
                  <h4 className="font-bold mb-1" style={{ color: '#111827' }}>
                    Centralized Platform
                  </h4>
                  <p className="text-sm lg:text-base" style={{ color: '#6b7280' }}>
                    Single source of truth for all product development activities
                  </p>
                </div>
              </div>
              <div 
                className="flex items-start gap-4 p-4 rounded-xl"
                style={{ backgroundColor: '#ecfdf5' }}
              >
                <CheckCircle className="w-6 h-6 mt-1 flex-shrink-0" style={{ color: '#10b981' }} />
                <div>
                  <h4 className="font-bold mb-1" style={{ color: '#111827' }}>
                    Real-time Collaboration
                  </h4>
                  <p className="text-sm lg:text-base" style={{ color: '#6b7280' }}>
                    Cross-functional teams working together seamlessly
                  </p>
                </div>
              </div>
              <div 
                className="flex items-start gap-4 p-4 rounded-xl"
                style={{ backgroundColor: '#ecfdf5' }}
              >
                <CheckCircle className="w-6 h-6 mt-1 flex-shrink-0" style={{ color: '#10b981' }} />
                <div>
                  <h4 className="font-bold mb-1" style={{ color: '#111827' }}>
                    Seasonal Management
                  </h4>
                  <p className="text-sm lg:text-base" style={{ color: '#6b7280' }}>
                    Track multiple collections and product lines efficiently
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative max-w-lg mx-auto lg:max-w-none">
            <div 
              className="absolute -inset-4 rounded-xl opacity-30 -rotate-2"
              style={{ background: 'linear-gradient(to bottom right, #d1fae5, #a7f3d0)' }}
            ></div>
            <img 
              src="https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=600&h=400&fit=crop&crop=center" 
              alt="Fashion Design Process" 
              className="relative rounded-xl shadow-2xl w-full h-auto"
            />
          </div>
        </section>
      </main>

      {/* Process Flow Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#f1f5f9' }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold mb-4" style={{ color: '#111827' }}>
              Fashion Development Process
            </h2>
            <p className="text-lg lg:text-xl" style={{ color: '#6b7280' }}>
              From concept to runway in record time
            </p>
          </div>
          
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div 
                className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg"
                style={{ backgroundColor: '#f59e0b' }}
              >
                <Sparkles className="w-10 h-10" style={{ color: '#ffffff' }} />
              </div>
              <h3 className="text-lg lg:text-xl font-bold mb-3" style={{ color: '#111827' }}>
                Concept
              </h3>
              <p className="text-sm lg:text-base" style={{ color: '#6b7280' }}>
                Design ideation and trend analysis
              </p>
            </div>
            
            <div className="text-center">
              <div 
                className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg"
                style={{ backgroundColor: '#3b82f6' }}
              >
                <Palette className="w-10 h-10" style={{ color: '#ffffff' }} />
              </div>
              <h3 className="text-lg lg:text-xl font-bold mb-3" style={{ color: '#111827' }}>
                Design
              </h3>
              <p className="text-sm lg:text-base" style={{ color: '#6b7280' }}>
                Creative development and tech specs
              </p>
            </div>
            
            <div className="text-center">
              <div 
                className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg"
                style={{ backgroundColor: '#10b981' }}
              >
                <Globe className="w-10 h-10" style={{ color: '#ffffff' }} />
              </div>
              <h3 className="text-lg lg:text-xl font-bold mb-3" style={{ color: '#111827' }}>
                Source
              </h3>
              <p className="text-sm lg:text-base" style={{ color: '#6b7280' }}>
                Global supplier collaboration
              </p>
            </div>
            
            <div className="text-center">
              <div 
                className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg"
                style={{ backgroundColor: '#8b5cf6' }}
              >
                <ShoppingBag className="w-10 h-10" style={{ color: '#ffffff' }} />
              </div>
              <h3 className="text-lg lg:text-xl font-bold mb-3" style={{ color: '#111827' }}>
                Launch
              </h3>
              <p className="text-sm lg:text-base" style={{ color: '#6b7280' }}>
                Market-ready products on time
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section 
        className="py-20 px-4 sm:px-6 lg:px-8"
        style={{ 
          background: 'linear-gradient(to bottom right, #1e40af, #3730a3, #581c87)', 
          color: '#ffffff'
        }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-5xl font-bold mb-6">
            Ready to Revolutionize Fashion Development?
          </h2>
          <p className="text-lg lg:text-xl mb-10 opacity-90 leading-relaxed">
            Join fashion leaders using Infor PLM to accelerate innovation, reduce costs, 
            and deliver collections faster than ever before.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button 
              className="px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 hover:scale-105 shadow-2xl"
              style={{ backgroundColor: '#ffffff', color: '#1e40af' }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#f3f4f6';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = '#ffffff';
              }}
            >
              Schedule Your Demo
            </button>
            <button 
              className="border-2 border-white bg-transparent px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 hover:bg-white hover:text-blue-800"
              style={{ color: '#ffffff' }}
            >
              Contact Fashion Experts
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#111827', color: '#ffffff' }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div 
                className="w-12 h-12 rounded-xl flex items-center justify-center"
                style={{ background: 'linear-gradient(to bottom right, #8b5cf6, #7c3aed)' }}
              >
                <Shirt className="w-8 h-8" style={{ color: '#ffffff' }} />
              </div>
              <span className="text-2xl lg:text-3xl font-bold">
                Infor PLM for Fashion
              </span>
            </div>
            <p className="text-lg mb-8" style={{ color: '#9ca3af' }}>
              Empowering PTKCS with cutting-edge fashion lifecycle management
            </p>
            <div className="border-t pt-8" style={{ borderTopColor: '#374151' }}>
              <p style={{ color: '#6b7280' }}>
                © 2025 PTKCS Fashion Solutions. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default InforPLMFashion;
